import { Directive, TemplateRef, ViewContainerRef, Input } from "@angular/core";
import { AuthService } from "../services/auth.service";

@Directive({
    selector: "[featureToggle]",
    standalone: false
})
export class FeatureToggleDirective {
    private hasView = false;

    constructor(private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef) {
    }

    @Input()
    set featureToggle(featureId: number) {
        const featureIndex = AuthService.businessFunction?.features?.findIndex(e => e.featureId === featureId && e.enabled) ?? -1;
        if (featureIndex > -1 && !this.hasView) {
            this.viewContainer.createEmbeddedView(this.templateRef);
            this.hasView = true;
        } else {
            this.viewContainer.clear();
            this.hasView = false;
        }
    }
}